module.exports = __webpack_public_path__ + "static/media/play-store-badge.589d3bef.svg";